import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { baseUrl } from "./Univ";

function AddElection() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ year: "", name: "" });

  const fetchData = () => {
    axios.get(baseUrl + "elections/").then(r => setRows(r.data));
  };

  useEffect(() => { fetchData(); }, []);

  const submit = () => {
    axios.post(baseUrl + "elections/", form).then(() => {
      Swal.fire("Saved", "Election added", "success");
      window.location.reload();
    });
  };

  const handleDelete = (id) => {
    axios.delete(baseUrl + "delete-elections/" + id + "/").then(fetchData);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "year", headerName: "Year", width: 120 },
    { field: "name", headerName: "Name", width: 200 },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (p) => (
        <button onClick={() => handleDelete(p.row.id)} className="btn btn-danger btn-sm">Delete</button>
      )
    }
  ];

  return (
    <section className="container mt-4">
      <div className="card">
        <h4 className="card-header">Add Election</h4>
        <div className="card-body">
          <input className="form-control mb-2" placeholder="Year"
            onChange={e => setForm({...form, year: e.target.value})}/>
          <input className="form-control mb-2" placeholder="Name"
            onChange={e => setForm({...form, name: e.target.value})}/>
          <button className="btn btn-primary" onClick={submit}>Save</button>
        </div>
      </div>
<div style={{ width: '100%' }}>
      <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
        />
        </div>
    </section>
  );
}

export default AddElection;